export const BUSINESS = {
  name: "Creative Designs Services",
  short: "CDS",
  tagline: "From Stress to Success",
  subtitle: "Professional Administrative & Creative Solutions",
  founder: "Mrs. Leticia Dean Capo Marquez",
  email: "creativedesignsservices@outlook.com",
  phones: ["242-823-0141", "242-466-5898"],
  domain: "creativedesignsservicesbahamas.com",
  location: "Nassau, The Bahamas",
  logo: "/brand-logo.png",
  founderPhoto: "/founder-portrait.png",
};

export const BIO = {
  headline: "Founder & Creative Professional",
  paragraphs: [
    "Mrs. Leticia Dean Capo Marquez is the founder and creative force behind Creative Designs Services, a professional business dedicated to providing high-quality creative, administrative, writing, and academic-support solutions. Guided by the motto “From Stress to Success,” she combines creativity, organisation, professionalism and personalised service to help individuals, businesses, students and community organisations bring their ideas to life.",
    "She is widely respected for her integrity, dependability, creativity, resilience and commitment to exceeding expectations. Her earlier leadership and customer-service roles within The Bahamas’ hospitality and tourism industries developed her expertise in client relations, marketing support, payroll coordination, staff supervision and administrative management.",
    "Her approach is grounded in integrity, excellence, confidentiality, accountability and attentive customer care. She takes time to understand each client’s needs and transforms their ideas, information and goals into polished, professional results — whether crafting an elegant promotional design, refining an important document, developing engaging content or providing administrative support.",
    "A devoted wife, mother, community-oriented leader and woman of faith, Mrs. Dean Capo Marquez believes that true success is achieved by serving others and helping them confidently reach their goals. Through Creative Designs Services, she remains committed to delivering reliable, creative and professional solutions that take every client “From Stress to Success.”",
  ],
};

export const CREDENTIALS = [
  "BA (Hons) Business Management — Edinburgh Napier University",
  "MBA in Health Management (in progress) — Edinburgh Napier University",
  "Certified Medical Administrative Assistant",
  "Diploma in Medical Billing & Coding",
  "Certificate in Human Resources Fundamentals",
  "Certified Office Administrator",
  "Associate of Arts in History",
];

export const VALUES = ["Integrity", "Excellence", "Confidentiality", "Accountability", "Attentive Care"];

export const SERVICES = [
  {
    num: "01",
    key: "creative-design",
    title: "Creative Design",
    icon: "PenNib",
    blurb: "Distinctive visual identities and print pieces crafted to make every occasion unforgettable.",
    items: [
      "Business Flyers", "Save-the-Date Flyers", "Funeral & Wedding Programs",
      "Invitations", "Banners", "Logos", "Email Newsletters",
      "Social Media Captions", "Content Creation",
    ],
  },
  {
    num: "02",
    key: "professional-writing",
    title: "Professional Writing",
    icon: "PenNibStraight",
    blurb: "Words that open doors — polished, persuasive and precisely tailored to you.",
    items: [
      "Résumés", "Cover Letters", "Case Studies",
      "PowerPoint Presentations", "Proofreading", "Editing", "Copy Typing",
    ],
  },
  {
    num: "03",
    key: "academic-support",
    title: "Academic Support",
    icon: "GraduationCap",
    blurb: "Rigorous, original academic help to carry you confidently through every deadline.",
    items: [
      "Coursework", "Academic Writing", "College Essays",
      "Research Papers", "Originality & AI-Use Reports",
    ],
  },
  {
    num: "04",
    key: "application-assistance",
    title: "Application Assistance",
    icon: "Stamp",
    blurb: "Guided, meticulous application preparation so your paperwork never stands in your way.",
    items: ["Business Licence Applications", "Immigration Applications"],
  },
];

export const MANIFESTO = [
  {
    num: "01",
    title: "Listen first",
    body: "Every project begins with your story. We take time to understand your goal, your audience and the feeling you want to leave behind.",
  },
  {
    num: "02",
    title: "Design with intention",
    body: "Nothing is decorative for its own sake. Every colour, word and line of type earns its place and moves you closer to success.",
  },
  {
    num: "03",
    title: "Deliver with care",
    body: "Print-ready, deadline-ready, worry-free. We handle the detail so you can trade stress for confidence — and results.",
  },
];

// Real client work uploaded by the studio
export const WORK = [
  { type: "video", src: "/work/work2.mp4", tag: "Animated Event Flyer", cat: "Motion Design", group: "Motion", caption: "A looping animated invitation that brought a private celebration to life across social media." },
  { type: "image", src: "/work/plp-thankyou.png", tag: "PLP Women's Branch — Thank You", cat: "Event Recap", group: "Flyers", caption: "A heartfelt thank-you recap for the New Providence Women's Branch after their first post-election meeting." },
  { type: "image", src: "/work/collage4.webp", tag: "Choose Progress Campaign", cat: "Campaign Flyer", group: "Flyers", caption: "Bold campaign artwork capturing the energy and unity of the Women's Branch movement." },
  { type: "image", src: "/work/brass-band.webp", tag: "Night of Legends — Save the Date", cat: "Save-the-Date", group: "Flyers", caption: "An elegant save-the-date honouring the world-famous Bahama Brass Band's Night of Legends." },
  { type: "image", src: "/work/invite.jpg", tag: "Wedding Reception Invitation", cat: "Invitations", group: "Invitations", caption: "A refined reception invitation designed for Leticia & Yasser's special day." },
  { type: "image", src: "/work/language-garden.png", tag: "Language Garden — Business Flyer", cat: "Business Flyer", group: "Flyers", caption: "Clean, nature-inspired branding for a Bahamian landscape-design company." },
  { type: "video", src: "/work/work1.mp4", tag: "Promotional Motion Piece", cat: "Motion Design", group: "Motion", caption: "A short promotional motion piece designed to stop the scroll and start the conversation." },
  { type: "image", src: "/work/img1.jpg", tag: "Freda “Melrose” Storr — Celebration", cat: "Funeral Program", group: "Programs", caption: "A dignified celebration-of-life program honouring the memory of Freda “Melrose” Storr." },
];

export const WORK_FILTERS = ["All", "Flyers", "Invitations", "Programs", "Motion"];

// Sample testimonials — replace with real client reviews any time
export const TESTIMONIALS = [
  { quote: "Leticia turned my rushed idea into a flyer that looked absolutely luxurious. My event sold out.", name: "Danielle R.", role: "Event Host · Nassau" },
  { quote: "My résumé finally sounds like me — polished and professional. I had two interviews within a week.", name: "Marcus T.", role: "Client · Freeport" },
  { quote: "The wedding invitations were breathtaking. Every guest asked who designed them.", name: "The Marquez Family", role: "Wedding Clients" },
  { quote: "Reliable, creative and so easy to work with. Truly from stress to success.", name: "Andrea K.", role: "Small Business Owner" },
];

export const GALLERY = [
  { src: "https://images.unsplash.com/photo-1758080159705-6dabe159d476?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", tag: "Wedding Suite", span: "tall" },
  { src: "https://images.unsplash.com/photo-1702479744181-2d6b58941583?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", tag: "Brand Identity", span: "wide" },
  { src: "https://images.unsplash.com/photo-1698047681432-006d2449c631?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", tag: "Résumé Design", span: "" },
  { src: "https://images.unsplash.com/photo-1473186505569-9c61870c11f9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", tag: "Editorial Writing", span: "" },
  { src: "https://images.unsplash.com/photo-1783818412147-fc24a0d05830?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", tag: "Programs", span: "wide" },
  { src: "https://images.unsplash.com/photo-1647108188039-4d5048f19a58?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", tag: "Creative Concepts", span: "tall" },
  { src: "https://images.unsplash.com/photo-1702479744120-98fffb81bf6d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", tag: "Print Collateral", span: "" },
  { src: "https://images.unsplash.com/photo-1586281380349-632531db7ed4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", tag: "Presentations", span: "" },
];

export const TEXTURES = {
  gold: "https://images.unsplash.com/photo-1760172287483-02d382f63a6f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};
